
   export const environment = {
    production: false
  };

  export const  APIURL= "https://ley-urgencia-api.banmedica.cl"
  
